/**
 * Set of custom serializers for the peer model system.
 */
define([
    "mw-utils/Utils",
    "./PagedData"
], function (Utils, PagedData) {

    var serializers = {};

    serializers.imageSerializer = function (data) {
        if (!this._serializerCanvas) {
            this._serializerCanvas = document.createElement("canvas");
            this._serializerContext = this._serializerCanvas.getContext("2d");
        }

        if (this._serializerCanvas.width !== data.width ||
            this._serializerCanvas.height !== data.height) {
            this._serializerCanvas.width = data.width;
            this._serializerCanvas.height = data.height;
        }

        this._serializerContext.putImageData(data, 0, 0);

        return this._serializerCanvas.toDataURL();
    };

    serializers.imageDeserializer = function (messageData) {
        var image = new Image();
        image.src = messageData;
        return image;
    };


    serializers.pagedDataSerializer = function (data) {
        return {
            rowCount: data.getRowCount(),
            columnCount: data.getColumnCount(),
            currentStartRow: data.getCurrentStartRow(),
            currentEndRow: data.getCurrentEndRow(),
            currentStartCol: data.getCurrentStartCol(),
            currentEndCol: data.getCurrentEndCol(),
            partialData: data.getPartialData()
        };
    };

    serializers.pagedDataDeserializer = function (messageData) {
        var data = serializers.messageService.deserialize(messageData);
        return new PagedData(data);
    };


    serializers.setupSerializers = function (messageService) {
        serializers.messageService = messageService;
        if (!messageService._peerModelSerializersSetup) {
            // note: this serializer/deserializer  is not symmetric. it takes ImageData in one way,
            // and returns out Image (potentially unloaded). This is to keep the method from
            // blocking on the image load.
            messageService.registerTypeSerializer(
                Utils.isImageData, "image", serializers.imageSerializer);
            messageService.registerTypeDeserializer("image", serializers.imageDeserializer);

            messageService.registerTypeSerializer(function (data) {
                return data instanceof PagedData;
            }, "pagedData", serializers.pagedDataSerializer);
            messageService.registerTypeDeserializer("pagedData", serializers.pagedDataDeserializer);
        }
        messageService._peerModelSerializersSetup = true;
    };


    return serializers;
});
